import { NgbDateStruct } from '@cmps/ng-bootstrap';
import { IOption } from '@cmps/ng-select';

import { CriteriaIdType } from '../insight/performance-data/metric.pd.model';
import { PeriodType } from '../widget/date-range.widget.model';

import { TranslationKeyMap } from './performance-insight.i18n';

export interface FilterOptions {
    periodType: PeriodType;
    eventDate: Date;
    eventDateNgb: NgbDateStruct;
    pathCategoryId: number;
    pathSubcategoryId: number;
    pathId: number;
    lobId: number;
    regionId: number;
    areaId: number;
    siteId: number;
    peerGroupId: number;
    superGroupId: number;
}

export interface LevelTplOpts {
    idKey: string;
    optsKey: string;
    name: string;
    label: string;
    placeholder: string;
    opts: IOption[];
}

interface CriteriaTypeLevelTplOpts {
    [key: number]: LevelTplOpts;
}

export const CriteriaTypeLevelTplOptsMap: CriteriaTypeLevelTplOpts = {
    [CriteriaIdType.USER_ID]: null,
    [CriteriaIdType.SUPER_GROUP_ID]: {
        idKey: 'superGroupId',
        optsKey: '_superGroupOpts',
        name: 'superGroup',
        label: TranslationKeyMap._67_SUPERGROUP,
        placeholder: TranslationKeyMap._834_SELECT_A_SUPERGROUP,
        opts: null,
    },
    [CriteriaIdType.PEER_GROUP_ID]: {
        idKey: 'peerGroupId',
        optsKey: '_peerGroupOpts',
        name: 'peerGroup',
        label: TranslationKeyMap._824_PEERGROUP,
        placeholder: TranslationKeyMap._833_SELECT_A_PEERGROUP,
        opts: null,
    },
    [CriteriaIdType.SITE_ID]: {
        idKey: 'siteId',
        optsKey: '_siteOpts',
        name: 'site',
        label: TranslationKeyMap._64_SITE,
        placeholder: TranslationKeyMap._652_SELECT_A_SITE,
        opts: null,
    },
    [CriteriaIdType.AREA_ID]: {
        idKey: 'areaId',
        optsKey: '_areaOpts',
        name: 'area',
        label: TranslationKeyMap._148_AREA,
        placeholder: TranslationKeyMap._976_SELECT_AN_AREA,
        opts: null,
    },
    [CriteriaIdType.REGION_ID]: {
        idKey: 'regionId',
        optsKey: '_regionOpts',
        name: 'region',
        label: TranslationKeyMap._149_REGION,
        placeholder: TranslationKeyMap._974_SELECT_A_REGION,
        opts: null,
    },
    [CriteriaIdType.LOB_ID]: {
        idKey: 'lobId',
        optsKey: '_lobOpts',
        name: 'lob',
        label: 'LOB', // TODO tl
        placeholder: 'Select a LOB', // TODO tl
        opts: null,
    },
    [CriteriaIdType.QUEUE_ID]: null,
    [CriteriaIdType.TEAM_ID]: null,
};
